module.exports = __webpack_public_path__ + "img/adele.ae54f897.png";